import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import React from "react";
import DeleteDialog from "../../components/DeleteDialog";
import { languages } from "../../constants/languages";

class DeletePouleContainer extends React.Component {
  state = {
    open: false,
    errorMessage: "",
    warningShown: false,
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open, errorMessage: "" });
    }
  };

  componentDidMount = () => {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  };

  handleDelete = () => {
    let hasScheduledMatches = false;
    for (let x in this.props.matches) {
      let oldMatch = this.props.matches[x];
      if (oldMatch.field !== null) {
        hasScheduledMatches = true;
      }
    }

    if (hasScheduledMatches && !this.state.warningShown) {
      this.setState({
        errorMessage: languages.tournament.areYouSure,
        warningShown: true,
      });
    } else {
      const db = window.firebase.firestore();

      let batch = db.batch();
      let mainBatches = [batch];
      let numInBatch = 0;
      let deleteMatchesBatches = this.deletePoule();

      const affectedPairs = new Set();
      for (let x in this.props.matches) {
        const match = this.props.matches[x];
        if (match.field !== null && match.field !== undefined) {
          const dayId = match.day || "0";
          affectedPairs.add(`${match.field}__${dayId}`);
        }
      }
      affectedPairs.forEach((pair) => {
        const [fieldId, dayId] = pair.split("__");
        if (numInBatch >= 499) {
          batch = db.batch();
          mainBatches.push(batch);
          numInBatch = 0;
        }
        batch.set(db.collection("cacheUpdates").doc(), {
          tournamentId: this.props.tournament[".key"],
          fieldId,
          dayId,
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
        numInBatch++;
      });

      if (this.props.tournament.ia) {
        if (numInBatch >= 499) {
          batch = db.batch();
          mainBatches.push(batch);
        }
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      Promise.all(deleteMatchesBatches.map((b) => b.commit())).then(() => {
        Promise.all(mainBatches.map((b) => b.commit()));
      });
      this.toggleDialog();
    }
  };

  deletePoule = () => {
    const db = window.firebase.firestore();
    const pouleRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("poules")
      .doc(this.props.poule.id);

    let batches = [];
    let batch = db.batch();
    batch.delete(pouleRef);
    let numInBatch = 1;

    for (let i = 0; i < this.props.teams.length; i++) {
      const team = this.props.teams[i];
      if (!team.empty) {
        let teamsOrResultSpots = "teams";
        if (team.resultSpot) {
          teamsOrResultSpots = "resultSpots";
        }
        const teamRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection(teamsOrResultSpots)
          .doc(team.id);

        let update = {};
        update["poule" + this.props.poule.fase] = null;
        batch.update(teamRef, update);
        numInBatch++;
        if (numInBatch > 499) {
          numInBatch = 0;
          batches.push(batch);
          batch = db.batch();
        }
      }
    }

    // delete matches
    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");
    for (let x in this.props.matches) {
      let oldMatch = this.props.matches[x];
      batch.delete(matchesRef.doc(oldMatch.id));
      numInBatch++;
      if (numInBatch > 499) {
        numInBatch = 0;
        batches.push(batch);
        batch = db.batch();
      }
    }

    // delete result spots
    const resultSpotsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots");
    for (let x in this.props.resultSpotsNotDivided) {
      let oldResultSpot = this.props.resultSpotsNotDivided[x];
      batch.delete(resultSpotsRef.doc(oldResultSpot.id));
      numInBatch++;
      if (numInBatch > 499) {
        numInBatch = 0;
        batches.push(batch);
        batch = db.batch();
      }
    }

    if (numInBatch > 0) {
      batches.push(batch);
    }

    return batches;
  };

  render() {
    let showLockMessage = false;
    if (this.props.tournament.scheduleLocked) {
      showLockMessage = true;
    }
    return (
      <div>
        {(!this.props.belongsToBracket ||
          (this.props.belongsToBracket && this.props.poule.losersFinal)) && (
          <IconButton
            aria-label="Delete"
            onClick={
              this.props.poule.losersFinal
                ? this.props.toggleLosersFinal
                : this.toggleDialog
            }
            style={{
              color:
                this.props.poule.losersFinal &&
                this.props.tournament.scheduleLocked
                  ? "lightgray"
                  : "white",
              width: 30,
              height: 20,
            }}
            disabled={
              this.props.matches.length === 0 ||
              (this.props.poule.losersFinal &&
                this.props.tournament.scheduleLocked)
            }
          >
            <DeleteIcon style={{ height: 20, position: "absolute", top: 2 }} />
          </IconButton>
        )}
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          title={
            this.props.singleMatch
              ? languages.structure.deleteMatch
              : languages.structure.deletePoule
          }
          description={
            this.props.singleMatch
              ? languages.structure.deleteMatchWarning
              : languages.structure.deleteWarning
          }
          errorMessage={
            showLockMessage
              ? languages.structure.scheduleLockMessage
              : this.state.errorMessage
          }
          deleteButtonDisabled={showLockMessage}
        />
      </div>
    );
  }
}

export default DeletePouleContainer;
